export default {
    INPUT: 'INPUT',
    LIST: 'LIST',
    RESPONSE: 'RESPONSE',
    CHECKOUT: 'CHECKOUT',
};
